import { Badge, BadgeType } from '../../../../../../../components/badge/badge';

import { IFeeItemDto } from '../../../refund-calculator-types';
import CalculatorLineItem from '../calculator-line-item/calculator-line-item';

interface ICalculatorCategoryProps {
    data: IFeeItemDto[];
    title: React.ReactNode;
}

const CalculatorFeesCategory: React.FC<ICalculatorCategoryProps> = ({ data, title = "" }) => {
    return (
        <div className="refund-calculator__category">
            {title}
            <div className="refund-calculator__category-items">
                {data.map((item, index) => {
                    let description: React.ReactNode | string = item.setting_label;
                    if (item.fee_state) {
                        description = (
                            <span>
                                {item.setting_label}
                                <span className="refund-calculator__category-badge">
                                    <Badge
                                        text={item.fee_state}
                                        type={item.fee_state.startsWith("Paid Separately") ? BadgeType.PRIMARY : BadgeType.WARNING}
                                    />
                                </span>
                            </span>
                        );
                    }
                    return (
                        <CalculatorLineItem
                            key={index}
                            description={description}
                            price={item.amount}
                            tax={item.tax}
                            taxRate={item.tax_rate || 0}
                        />
                    )
                })}
            </div>
        </div>
    );
};

export default CalculatorFeesCategory;
